import { gql } from '@apollo/client';

export default gql`
  query profileSubscriptionBookings(
    $customerId: String!
    $travelPassReference: String!
    $bookingSearchType: BookingSearchType!
    $page: Int!
    $size: Int!
  ) {
    profileSubscriptionBookings(
      customerId: $customerId
      travelPassReference: $travelPassReference
      bookingSearchType: $bookingSearchType
      page: $page
      size: $size
    ) {
      items {
        reference
        origin
        destination
        tickets {
          serviceClass
          departureDate
          departureTime
          origin
          originCode
          destination
          destinationCode
          numberOfPassengers
          isCancelled
          products {
            code
            isCancelled
          }
        }
      }
      pagination {
        totalItems
        currentPage
        totalPages
      }
    }
  }
`;
